export default {
	name	: 'MainSelect',
	props	: {
		value		: [String, Number],
		label		: String,
		placeholder	: String,
		disabled	: Boolean,
		required	: Boolean,
		errorMessage: String,
		options		: {
			type		: Array,
			required	: true,
			// [{value: '1', label: 'Опція 1'}]
		}
	}
}
